<template>
  <div>
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/navigator/bbs` }">{{ serviceMsg.serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/navigator/bbs/bbsNav/microCommunity' }">{{serviceMsg.children[0].type === 15 ? serviceMsg.children[0].serviceName : serviceMsg.children[1].serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item>发帖</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="uploadCover boxShadow">
      <h3 class="title">上传封面</h3>
        <!-- <el-upload
          class="avatar-uploader" name='file' :multiple='false' accept='image/gif, image/jpeg, image/png'
          action="http://up-z2.qiniup.com/" :data='{ token: this.qiniuConfig.token }'
          :show-file-list="false" :on-success='uploadSuccess'
          :disabled="!isEdit">
          <img v-if="userInfo.userIcon" :src="userInfo.userIcon" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload> -->

      <el-upload
        class="avatar-uploader"
        name='file' :multiple='false' accept='image/gif, image/jpeg, image/png'
        action="http://up-z2.qiniup.com/" :data='{ token: this.qiniuConfig.token }'
        :show-file-list="false"
        :on-success="uploadSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="uploadMsg.thumb" :src="uploadMsg.thumb" class="avatar">
        <div v-else class="avatar-uploader-icon">
          <i class="el-icon-circle-plus-outline"></i>
          <p>上传封面</p>
        </div>
      </el-upload>
    </div>

    <div class="boxShadow uploadTitle">
        <h3 class="title">标题</h3>
        <el-input placeholder="请输入标题" v-model="uploadMsg.subject" :maxlength="100"></el-input>
    </div>


    <div class="uploadContent boxShadow">
      <h3 class="title">编辑内容</h3>
       <div class="editor-container">
        <UE :defaultMsg=defaultMsg :config=config :id=ue1 ref="ue"></UE>
        <!-- <UE :defaultMsg=defaultMsg :config=config :id=ue2 ref="ue2"></UE> -->
      </div>
    </div>

   <div class="check">
      <el-checkbox v-model="checked"></el-checkbox>
      <span class="alreadyRead">我已阅读,并同意</span>
      <span class="rules" @click="dialogVisible= true">《天安智慧云BBS发帖规则》</span>
      <p><el-button class="btn-fill" type="primary" @click="getUEContent">发布</el-button></p>
      <!-- <router-link to="/navigator/bbs/bbsRules" class="rules">
        《天安智慧云BBS发帖规则》
      </router-link> -->
   </div>
    <!-- <button @click="getUEContent">获取内容</button>
    <button @click="getUEContentTxt">获取无文本内容</button> -->




    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      :lock-scroll="true"
      center
      >
      <BbsRules style="height: 400px;overflow: auto;"></BbsRules>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

   <!-- 弹窗登录 -->
    <MaskLogin v-show='showLogin' @close='showLogin = false;'></MaskLogin>

    <!-- 消息弹框 -->
    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg="tipsMsg"></SubmitSuccess>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UE from '@/components/UE';
import BbsRules from '../components/BbsRules';

export default {
  data() {
    return {
      showLogin: false,
      submitSuccessFlag: false,
      dialogVisible: false,
      tipsMsg: '',
      loading: false,
      checked: '',
      qiniuConfig: {},
      // ue配置
      defaultMsg: '',
        config: {
          initialFrameWidth: 1024,
          initialFrameHeight: 300
        },
      ue1: 'ue1', // 不同编辑器必须不同的id
      uploadMsg: {
        thumb: '',
        subject: '',
        value: '',
      },
      serviceMsg: {},
    };
  },
  methods: {
    beforeAvatarUpload(file) {
      if (!this.token) {
        this.showLogin = true;
        return false;
      }
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpg,gif,png 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isJPG && isLt2M;
    },
    getUEContent() {
      let content = this.$refs.ue.getUEContent(); // 调用子组件方法

      if (!this.uploadMsg.subject) {
        this.$message.error('请填写标题');
        return;
      }
      if (this.uploadMsg.subject.length > 100) {
        this.$message.error('标题最多支持100个字符');
        return;
      }
      if (!this.uploadMsg.thumb) {
        this.$message.error('请上传封面图片');
        return;
      }
      if (!content) {
        this.$message.error('请编辑内容');
        return;
      }
      if (!this.checked) {
        this.$message.error('请阅读并同意《天安智慧云BBS发帖规则》');
        return;
      }
      this.uploadMsg.content = content;
      this.$http.post(`${this.URL_PREFIX}/app/added/bbs/post`, {
        parkId: this.currentParkId,
        ...this.uploadMsg,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.submitSuccessFlag = true;
        if (res.resCode === '10000') {
          this.tipsMsg = '发帖成功！';
          setTimeout(() => {
            this.$router.push({ path: `/navigator/bbs/postContent/${res.resData.id}` })
          }, 1500);
        } else {
          this.tipsMsg = res.resDesc;
        }
      });
    },
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
      // 图像上传成功
    uploadSuccess(res, file) {
      this.uploadMsg.thumb = `${this.qiniuConfig.domain}/${res.key}`;
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user', 'parkServiceList']),
  },
  components: {
    UE, BbsRules,
  },
  created() {
    if (this.token) {
      this.getUploadToken();
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 8;
      });
    } else {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss';


.uploadCover {
  background-color: #fff;
  height: 442px;
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader-icon {
    margin: 40px;
    background-color: #ebebeb;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    color: #8c939d;
    width: 300px;
    height: 200px;
    padding-top: 100px;
    i {
      font-size: 40px;
      color: #666;
    }
    p {
      margin-top: 14px;
      font-size: 16px;
      color: #666;
    }
    // line-height: 50px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .avatar {
    margin: 40px;
    width: 300px;
    height: 300px;
    display: block;
    border-radius: 4px;
  }
}

.uploadTitle {
  background-color: #fff;
  margin: 20px 0;
  .el-input {
    width: 1000px;
    margin: 30px 40px;
  }
}

.uploadContent {
  background-color: #fff;
  padding-bottom: 30px;
  .editor-container {
    margin: 30px 40px;
    margin-bottom: 0;
  }
}

.check {
  line-height: 40px;
  padding-left: 0px;
  margin: 20px 0 40px 0;
  .el-button {
    margin-top: 20px;
  }
  .alreadyRead {
    margin-left: 4px;
    font-size: 14px;
  }
  .rules {
    font-size: 14px;
    cursor: pointer;
    color: $color-main;
  }
}
.title {
  padding-left: 40px;
  line-height: 60px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #f5f5f5;
}

.submit-success {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

</style>



// WEBPACK FOOTER //
// src/pages/navigator/bbs/microCommunity/SendPost.vue